import {
  BarSegmentChartProps,
  getCurrentRange,
  IBarSegmentConfig,
} from '../../components/bar-segment-chart/bar-segment-chart';

export default function updateBarChartProps(
  config: IBarSegmentConfig,
  lastRecord: Record<string, any>,
): BarSegmentChartProps {
  let indicatorConfig = { left: `0`, color: config.ranges[0].color };

  if (lastRecord) {
    const currentValue = lastRecord[config.indicatorKey];
    const currentRange = getCurrentRange(currentValue, config.ranges);
    const minSection = Math.abs(currentRange.from - currentRange.to);
    const percentage = ((currentValue - currentRange.from) / minSection) * 100;
    const sectionPercentage = 100 / config.ranges.length;
    const rangeInPercent = Math.min(
      (percentage / 100) * sectionPercentage + currentRange.pos * sectionPercentage,
      100,
    );

    indicatorConfig = { left: `${rangeInPercent}%`, color: currentRange.color };
  }

  const lineWidth = `${100 / config.ranges.length}%`;

  const labels = updateLabelsFromLastRecord(config, lastRecord);

  return { indicatorConfig, lineWidth, labels, ranges: config.ranges, isEmpty: !lastRecord };
}

function updateLabelsFromLastRecord(
  config: IBarSegmentConfig,
  lastRecord: Record<string, any> | null,
) {
  const updatedLabels = [];

  for (let i = 0; i < config.labels.length; i++) {
    const label = config.labels[i];

    const labelValue = lastRecord ? lastRecord[label.valueKey] : null;
    if (!!labelValue) {
      label.displayedValue = `${Number(labelValue).toFixed(0)}`;

      const range = config.ranges.find(
        (range) => labelValue > range.from && labelValue <= range.to,
      );

      if (label.updateColorFromRange) {
        if (range?.color) {
          label.color = range.color;
        }
      }

      if (label.addRangeToDisplayedValue) {
        if (range?.name) {
          label.displayedValue = `${label.displayedValue} ${range.name}`;
        }
      } else if (label.addUnitToDisplayedValue) {
        label.displayedValue = `${label.displayedValue}${label.unit}`;
      }

      if (label.replaceDescriptionWithRange) {
        if (range?.name) {
          label.descriptionKey = `life_id:status.label.${range.name}`;
        }
      }
    } else {
      // console.log('-- no value found for label: ', { label, lastRecord });
    }
    updatedLabels[i] = label;
  }
  return updatedLabels;
}
